export default function Quote({heading, content}) {
    return (
        <div className="qoute-content">
            <h2 className="mb-lg-4">{heading}</h2>
            <p className="lead mb-0">{content}</p>
        </div>
    )
}